export const getMinutesBetween = (from: Date, to: Date) => {
  const miliseconds = +to - +from
  return Math.floor(miliseconds / 60000)
}
